import { RootState } from "@base/store";
import Button from "@components/atoms/button";
import { homeActions } from "@components/features/home/home.slice";
import { settingsActions } from "@components/features/settings/settings.slice";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import React, { useEffect, useState } from "react";
import { ConnectedProps, connect } from "react-redux";

import {
  ActionWrapper,
  DialogContentText,
  DialogTitle,
} from "./planModal.styled";

type ReduxProps = ConnectedProps<typeof connector>;

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PlanModal = ({
  hasUserExceededPlan,
  setHasUserPlanExceeded,
  createStripeCheckoutSession,
  planMsg,
}: ReduxProps) => {
  const [planUrl, setPlanUrl] = useState("");
  const handleClose = () => {
    setHasUserPlanExceeded(false);
    setPlanUrl("");
  };

  const handleSubscription = async () => {
    const res = await createStripeCheckoutSession();
    if (res?.meta.requestStatus === "fulfilled") {
      setPlanUrl(res?.payload?.url);
    }
  };

  useEffect(() => {
    if (hasUserExceededPlan) {
      handleSubscription();
    }
  }, [hasUserExceededPlan]);

  return (
    <>
      <Dialog
        open={hasUserExceededPlan!}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Upgrade Required."}</DialogTitle>
        <DialogContent>
          <DialogContentText>{planMsg}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <ActionWrapper>
            <Button
              textColor={"#FFF"}
              text={"Upgrade"}
              type={"button"}
              onClick={() => {
                window.open(planUrl, "_blank");
                handleClose();
              }}
            />
          </ActionWrapper>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  hasUserExceededPlan: state.user.hasUserExceededPlan,
  planMsg: state.user.planMsg,
});

const mapDispatchToProps = {
  setHasUserPlanExceeded: homeActions.setHasUserExceededPlan,
  createStripeCheckoutSession: settingsActions.createStripeCheckoutSession,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const PlanModalRedux = connector(PlanModal);

export { PlanModalRedux as PlanModal };
